import {Sprite} from 'pixi.js';
import {Button, Text} from '@gongxigames/framework/core';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {SlotSettings} from '@gongxigames/framework/slot/configs/SlotSettings';
import {IAutoplayView} from '@gongxigames/framework/slot/modules/autoplay/IAutoplayView';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad';
import {View} from '@gongxigames/framework/slot/fragments/module/view';

export abstract class AutoplayView extends View<GlobalEventsMapForBackwardCompatibility> implements IAutoplayView {
    public static readonly STOP_AUTOPLAY_BUTTON_CLICKED: symbol = Symbol('STOP_AUTOPLAY_BUTTON_CLICKED');

    protected _autoplayFieldText!: Text;
    protected _stopAutoplayButton!: Button;
    protected _disabledAutoplayButton = false;

    public init(): void {
        this._disabledAutoplayButton = this.getSettings<SlotSettings>().get('autoSpinDisabled');

        this.initGraphicElements();
    }

    protected initGraphicElements(): void {
        this._stopAutoplayButton = this.mainSprite.getChildByName<Button>('stopAutoplayButton');
        this._stopAutoplayButton.visible = false;
        this._stopAutoplayButton.callback = this.onStopAutoplayButtonClicked.bind(this);
    }

    public hideAutoplayUI(): void {
        this._stopAutoplayButton.visible = false;
    }

    public showAutoplayUI(): void {
        this._stopAutoplayButton.visible = true;
    }

    public enableStopAutoplayButton(): void {
        this._stopAutoplayButton?.enable();
    }

    public disableStopAutoplayButton(): void {
        this._stopAutoplayButton?.disable();
    }

    public abstract setAutoplayFieldText(text: string): void;

    public abstract stopAutoplayButtonClickAction(): void;

    protected onStopAutoplayButtonClicked(): void {
        this.soundPlayer.play('buttonclick');
        this.emit(AutoplayView.STOP_AUTOPLAY_BUTTON_CLICKED);
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadView.NAME).mainSprite;
    }
}
